import Logo from "@/components/Logo";

const HeaderDiagnostico = () => {
  return (
    <header className="absolute top-0 left-0 right-0 z-50 py-6">
      <div className="section-container">
        <div className="flex items-center justify-between">
          <Logo size="sm" />
        </div>
      </div>
    </header>
  );
};

export default HeaderDiagnostico;
